import { ProductPageTemplate } from "@/components/products/ProductPageTemplate";
import {
  MapPin, Layers, Flame, Route, Circle, Database,
  Code, Globe, BarChart3, Truck, DollarSign, Link2,
  Ruler, Users,
} from "lucide-react";
import iconAtlas from "@/assets/icon-atlas.jpg";
import type { FeatureGroup, UseCase, Benefit } from "@/components/products/types";
import { AtlasWorkflowAnimation } from "@/components/products/AtlasWorkflowAnimation";
import { RoutingSection } from "@/components/products/atlas-routing/RoutingSection";

const featureGroups: FeatureGroup[] = [
  {
    titleKey: "productPages.atlas.featureGroups.createAndVisualize",
    illustrationKey: "atlas-create",
    features: [
      {
        titleKey: "productPages.atlas.features.items.points.title",
        descriptionKey: "productPages.atlas.features.items.points.description",
        icon: MapPin,
      },
      {
        titleKey: "productPages.atlas.features.items.areas.title",
        descriptionKey: "productPages.atlas.features.items.areas.description",
        icon: Layers,
      },
      {
        titleKey: "productPages.atlas.features.items.heatmaps.title",
        descriptionKey: "productPages.atlas.features.items.heatmaps.description",
        icon: Flame,
      },
    ],
  },
  {
    titleKey: "productPages.atlas.featureGroups.calculateAndAnalyze",
    illustrationKey: "atlas-calculate",
    features: [
      {
        titleKey: "productPages.atlas.features.items.routes.title",
        descriptionKey: "productPages.atlas.features.items.routes.description",
        icon: Route,
      },
      {
        titleKey: "productPages.atlas.features.items.measure.title",
        descriptionKey: "productPages.atlas.features.items.measure.description",
        icon: Ruler,
      },
      {
        titleKey: "productPages.atlas.features.items.attributes.title",
        descriptionKey: "productPages.atlas.features.items.attributes.description",
        icon: Database,
      },
    ],
  },
  {
    titleKey: "productPages.atlas.featureGroups.integrateAndShare",
    illustrationKey: "atlas-integrate",
    features: [
      {
        titleKey: "productPages.atlas.features.items.iframe.title",
        descriptionKey: "productPages.atlas.features.items.iframe.description",
        icon: Globe,
      },
      {
        titleKey: "productPages.atlas.features.items.api.title",
        descriptionKey: "productPages.atlas.features.items.api.description",
        icon: Code,
      },
    ],
  },
];

const useCases: UseCase[] = [
  {
    titleKey: "productPages.atlas.useCases.items.salesDistricts.title",
    descriptionKey: "productPages.atlas.useCases.items.salesDistricts.description",
    icon: Users,
  },
  {
    titleKey: "productPages.atlas.useCases.items.deliveryZones.title",
    descriptionKey: "productPages.atlas.useCases.items.deliveryZones.description",
    icon: Truck,
  },
  {
    titleKey: "productPages.atlas.useCases.items.priceZones.title",
    descriptionKey: "productPages.atlas.useCases.items.priceZones.description",
    icon: DollarSign,
  },
  {
    titleKey: "productPages.atlas.useCases.items.biConnection.title",
    descriptionKey: "productPages.atlas.useCases.items.biConnection.description",
    icon: BarChart3,
  },
  {
    titleKey: "productPages.atlas.useCases.items.distanceCalc.title",
    descriptionKey: "productPages.atlas.useCases.items.distanceCalc.description",
    icon: Route,
  },
  {
    titleKey: "productPages.atlas.useCases.items.crmConnection.title",
    descriptionKey: "productPages.atlas.useCases.items.crmConnection.description",
    icon: Link2,
  },
];

const benefits: Benefit[] = [
  {
    titleKey: "productPages.atlas.benefits.items.time.title",
    descriptionKey: "productPages.atlas.benefits.items.time.description",
  },
  {
    titleKey: "productPages.atlas.benefits.items.decisions.title",
    descriptionKey: "productPages.atlas.benefits.items.decisions.description",
  },
  {
    titleKey: "productPages.atlas.benefits.items.overview.title",
    descriptionKey: "productPages.atlas.benefits.items.overview.description",
  },
];

const AtlasPage = () => {
  return (
    <ProductPageTemplate
      productKey="atlas"
      icon={iconAtlas}
      featureGroups={featureGroups}
      useCases={useCases}
      benefits={benefits}
      accentClass="bg-petrol-light"
      demoPlaceholder={<AtlasWorkflowAnimation />}
      additionalSections={[
        { position: "after-workflow", component: <RoutingSection /> },
      ]}
    />
  );
};

export default AtlasPage;
